






























































































































































































import Accordion from "@/components/shared/Accordion.vue";
import SearchPagination from "@/components/shared/SearchPagination.vue";
import { Page } from "@/model/component.model";
import { DeviceManagementDTO } from "@/model/data.model";
import { getDeviceManagementTable, revokeDevice } from "@/services/AuthService";
import moment from "moment";
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    MbeSearchPagination: SearchPagination,
    Accordion
  }
})
export default class DeviceManagement extends Vue {
  list: DeviceManagementDTO[] = [];
  currentPage = 1;
  pageSize = 25;
  sort: string[] = [];
  showFilters = true;
  pagination = {
    first: false,
    last: false,
    number: 0,
    numberOfElements: 0,
    size: 25,
    sort: null,
    totalElements: 0,
    totalPages: 0,
    content: []
  } as Page;
  dateFilter: moment.Moment[] = [moment().subtract(1, "month"), moment()];
  filters = {
    username: "",
    approvedBy: "",
    fromData: "",
    toData: ""
  };

  get currentPageIndex() {
    return this.currentPage - 1;
  }

  async loadTable(tableFilter?: any) {
    try {
      const res = await getDeviceManagementTable(
        this.currentPageIndex,
        this.pageSize,
        this.filters
      );
      this.pagination = res;
      this.list = this.pagination.content;

      if (tableFilter.username) {
        this.list = this.list.filter(item =>
          item.username
            .toLowerCase()
            .includes(tableFilter.username.toLowerCase())
        );
      }
    } catch (err) {
      console.error(err);
    }
  }

  async created() {
    const oneMonthAgo = moment().subtract(1, "month");
    this.filters.fromData = oneMonthAgo.startOf("day").toISOString();
    this.filters.toData = moment()
      .endOf("day")
      .toISOString();
    await this.loadTable(this.filters);
  }

  executeSearch(value: any) {
    this.loadTable(value);
  }

  revokeAuth(user: any) {
    revokeDevice(user.id)
      .then(res => {
        this.$notify.success(this.$t("revoked"));
      })
      .catch(err => {
        this.$notify.error(this.$t("something_wrong"));
      });
    this.loadTable(this.filters);
  }

  convertDate(value: any) {
    return moment(value).format("DD/MM/YYYY HH:mm:ss");
  }

  handleDateChange(value: any) {
    if (value && value.length === 2) {
      this.filters.fromData = moment(
        value[0],
        "ddd MMM DD YYYY HH:mm:ss"
      ).toISOString();
      this.filters.toData = moment(
        value[1],
        "ddd MMM DD YYYY HH:mm:ss"
      ).toISOString();
    } else {
      this.filters.fromData = "";
      this.filters.toData = "";
    }
    this.loadTable(this.filters);
  }
}
